// TODO: Needs Cleanup and consolidation with course-tile-menu
import { IQuery } from 'core-ts-types';
import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { APCourse } from '../../../global/builders/ap_course_builder';
import { APGenericSlot, CourseSlot } from '../../../global/builders/ap_generic_slot_builder';
import { APCourseInfoModel } from '../../../global/components/course_detail/models/course_info_model';
import { APCourseInfoQuery } from '../../../global/components/course_detail/queries/ap_course_info_query';
import { APUserModeConfig } from '../../../global/components/user_mode_config/config/ap_user_mode_config';
import { IAPCoursesDatasource } from '../../../global/datasources/ap_courses_datasource';
import { IAPPlannedCourseDataSource } from '../../../global/datasources/ap_planned_course_datasource';
import { RouterHelper } from '../../../global/helpers/router_helper';
import { APComponentStateModel } from '../../../global/models/ap_component_state_model';
import { APGenericSlotServant } from '../../../global/servants/ap_generic_slot_servant';
import { MarkAsMetFacade } from './../../../global/components/mark_as_met/facades/mark_as_met_facade';
interface ITermEntry {
  id: number;
  name: string;
}

class CourseDetailsMenuController {
  private genericSlot: CourseSlot;
  private isAdvisor: boolean;
  private isPlanned: boolean = false;
  private hasMetRequirements: boolean = true;
  private courseLock: boolean = false;
  private showLockCourseOption: boolean;
  private showUnlockCourseOption: boolean;
  private showAddToTermMenu: boolean = false;
  private showFlagCourseMenu: boolean = false;
  private showRemoveFromTermMenu: boolean = false;
  private popupMenuId: string;
  private openLockDialog: boolean = false;
  private lockDialogMode: string = 'lock';
  private disableFavorite: boolean = false;
  private isFromSmartCat: boolean = false;
  private addToTermMenuItemText: string = 'Add Course to Term';
  private showSmartCatAddToTermOption: boolean = true;
  private showSmartCatRemoveFromTermOption: boolean = true;

  constructor(
    private $state: ng.ui.IStateService,
    private removeCourseFromTermCommand: ICommand,
    private ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource,
    private saveCourseToTermCommand: ICommand,
    private removeCourseFromTermAndAddCourseCommand: ICommand,
    private ngAPTermsQuery: IQuery,
    private ngAPUserModeConfig: APUserModeConfig,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngAPComponentStateModel: APComponentStateModel,
    private routerHelper: RouterHelper,
    private phxAxTitleAnnouncerDelegate: any,
    private unsaveFavoriteCourseCommand: ICommand,
    private saveFavoriteCourseCommand: ICommand,
    private ngAPCoursesDatasource: IAPCoursesDatasource,
    private markAsMetFacade: MarkAsMetFacade,
    private ngAPCourseInfoModel: APCourseInfoModel,
    private ngAPCourseInfoQuery: APCourseInfoQuery
  ) {
    this.popupMenuId = _4.uniqueId();
  }

  initialize() {
    this.isAdvisor = this.ngAPUserModeConfig.isAdvisor();
    this.isPlanned = APGenericSlotServant.isGenericSlotPlanned(this.genericSlot);
    this.hasMetRequirements = !this._hasRequisiteProblem;
    this.courseLock = _4.get(this.genericSlot, 'isLockedByAdvisor', false);
    this.showAddToTermMenu =
      this.showSmartCatAddToTermOption && _4.get(this.genericSlot, 'shouldShowAddToTermMenu', false);
    this.showRemoveFromTermMenu =
      this.showSmartCatRemoveFromTermOption && this.isPlanned && !this.genericSlot.isLockedByStatus;
    this.showFlagCourseMenu = this.isPlanned && this.isAdvisor;
    const isInPastTerm = this.isCourseCompleted && this.genericSlot.isLockedByStatus;
    this.addToTermMenuItemText =
      this.isPlanned && !(isInPastTerm && !this.isMinGradeMet) ? 'Move to Term' : 'Add Course to Term';
  }

  get isCourseCompleted() {
    return _4.get(this.genericSlot, 'isCourseCompleted', false);
  }

  get isMinGradeMet() {
    return _4.get(this.genericSlot, 'isMinGradeMet', false);
  }

  $onInit() {
    this.initialize();
  }

  $onChanges() {
    this.smartCatOptions();
    this.initialize();
  }

  smartCatOptions() {
    this.showSmartCatAddToTermOption = this.ngAPCourseInfoQuery.result.showSmartCatAddToTermOption;
    this.showSmartCatRemoveFromTermOption = this.ngAPCourseInfoQuery.result.showSmartCatRemoveFromTermOption;
  }

  // temporary hacking code. need change with hi-menu/hi-drawer combination on tabindex
  menuOpenedChanged(e: CustomEvent) {
    const menu = document.getElementById(`menu-course-tile-${this.popupMenuId}`);
    if (menu) {
      menu.setAttribute('tabindex', '-1');
    }
  }

  get lockTooltipText() {
    if (!this.courseLock) {
      return '';
    }
    const termName = _4.get(_4.find(this.ngAPTermsQuery.result.plannedTerms, { id: this.genericSlot.termId }), 'name');
    return `This course is locked and will be unlocked at the end of the ${termName} term.`;
  }

  get _hasRequisiteProblem() {
    return _4.get(this.genericSlot, 'plannedCourse._hasRequisiteProblem', false);
  }

  onMouseHover(event: any) {
    this.showLockCourseOption = !this.courseLock && this.isPlanned && this.isAdvisor;
    this.showUnlockCourseOption = this.courseLock && this.isPlanned && this.isAdvisor;
  }

  openFlagPopup() {
    const courseFlagRoute = this.routerHelper.isValidState(this.$state.current.name + '.course_flag_dialog')
      ? '.course_flag_dialog'
      : '^.course_flag_dialog';
    this.$state.go(courseFlagRoute, {
      genericSlot: this.genericSlot
    });
  }

  favoriteCourse() {
    this.toggleFavoriteCourse(`saveFavoriteCourseCommand`);
  }

  unfavoriteCourse() {
    this.toggleFavoriteCourse(`unsaveFavoriteCourseCommand`);
  }

  toggleFavoriteCourse(command: string) {
    const course = this.genericSlot.course;
    this[`${command}`](course).then((updatedCourse: APCourse) => {
      const courseInfoToUpdate = this.ngAPCourseInfoModel.read();
      courseInfoToUpdate.course[`${updatedCourse.id}`] = updatedCourse;
      this.ngAPCourseInfoModel.write(courseInfoToUpdate);
    });
  }
  getSlot() {
    return {
      id: _4.get(this.genericSlot.programSlot, 'id', null) || _4.get(this.$state, 'params.slotId', null)
    };
  }

  removeCourse() {
    if (!this.isPlanned) {
      return;
    }

    this.removeCourseFromTermCommand(this.genericSlot.programSlot, this.genericSlot.plannedCourse)
      .then(() => {
        const termTitle = _4.get(
          _4.find(this.ngAPTermsQuery.result.plannedTerms, { id: this.genericSlot.termId }),
          'name'
        );
        this.phxAxTitleAnnouncerDelegate.announceChange(
          `${_4.get(this.genericSlot, 'plannedCourse._course.title')} was removed from ${termTitle}`
        );
      })
      .then(() => {
        this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
      });
  }

  get shouldReplanCourse() {
    return this.genericSlot.isCourseCompleted && !this.genericSlot.isMinGradeMet;
  }

  moveToTerm(term: ITermEntry) {
    const coursePlanningSource = _4.get(this.ngAPCourseInfoQuery, 'result.coursePlanningSource', 'PLANNER');
    if (this.isPlanned && !this.shouldReplanCourse) {
      this.removeCourseFromTermAndAddCourseCommand(
        this.genericSlot.plannedCourse,
        this.genericSlot.course,
        this.genericSlot.programSlot || null,
        this.genericSlot.termId,
        term.id
      ).then((response: any) => {
        this.phxAxTitleAnnouncerDelegate.announceChange(
          `course ${this.genericSlot.course.title} was moved to ${term.name}`
        );
      });
    } else {
      const slot = this.getSlot();
      const is_devreq = _4.get(this.genericSlot, 'programSlot.is_devreq', false);

      this.saveCourseToTermCommand(
        this.genericSlot.course.id,
        term.id,
        slot,
        is_devreq,
        null,
        coursePlanningSource
      ).then((response: any) => {
        this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
        if (_4.get(this.genericSlot, 'programSlot.id', false)) {
          this.ngAPComponentStateModel.courseGroupClose(this.genericSlot.programSlot.id);
        }
        this.phxAxTitleAnnouncerDelegate.announceChange(`${this.genericSlot.title} added to ${term.name}`);
      });
    }
  }

  openLockUnlockDialog(mode: string) {
    return this.routerHelper.findStateAndGo('.lock_course', {
      genericSlot: this.genericSlot,
      type: mode
    });
  }
}

class CourseDetailsMenu implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      disableFavorite: '<?',
      genericSlot: '<',
      isFromSmartCat: '<'
    };
    this.controller = CourseDetailsMenuController;
    this.templateUrl =
      'capability-ng-academic-planner/src/smart_catalog/components/course_details_menu/course_details_menu.html';
  }
}

angular.module('capability-ng-smartcatalog').component('courseDetailsMenu', new CourseDetailsMenu());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/components/course_details_menu/course_details_menu.ts